import type { TournamentData } from '../platform/Platform';

export function isTournamentValid(tournamentData: TournamentData): boolean {
  return Date.now() < tournamentData.endsAt;
}
